'use client'

// React Imports
import {ReactNode, useEffect, useState} from 'react'

// Third-party Imports
import classnames from 'classnames'

// Type Imports
import type {ChildrenType} from '@core/types'

// Component Imports
import LayoutContent from './components/vertical/LayoutContent'

// Util Imports
import {verticalLayoutClasses} from './utils/layoutClasses'

// Styled Component Imports
import StyledContentWrapper from './styles/vertical/StyledContentWrapper'
import {getDictionary} from "@/utils/getDictionary";
import type {Locale} from "@configs/i18n";
import Fade from "@mui/material/Fade";
import {useSessionContext} from "@layouts/SessionContext";

export type VerticalLayoutProps = ChildrenType & {
    navigation?: ReactNode
    navbar?: ReactNode
    footer?: ReactNode,
}

const VerticalLayout = (props: VerticalLayoutProps) => {
    const session: any = useSessionContext();
    const sessionContext: any = session.sessionContext;
    // Props
    const {navbar, footer, navigation, children} = props

    return sessionContext?.session && sessionContext.session?.user ? (
        <Fade in timeout={300}>
            <div className={classnames(verticalLayoutClasses.root, 'flex flex-auto')}>
                {navigation || null}
                <div className={'flex'} style={{width: '100%'}}>
                    {/*<div style={{width: '17%'}} className="background-svg-dati min-bs-[100dvh] relative max-md:hidden"></div>*/}

                    <div
                        className="hidden lg:block lg:shrink-0"
                        style={{ width: "13%", minWidth: "350px" }}
                    >
                        <div
                            className="background-svg-dati"
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "13%",
                                minWidth: "350px",
                                height: "100vh",
                            }}
                        ></div>
                    </div>

                    <div style={{flex: 1, minWidth: 0}}
                         className={classnames(verticalLayoutClasses.contentWrapper, 'flex flex-col')}>

                        {navbar || null}
                        {/* Content */}
                        <LayoutContent>{children}</LayoutContent>
                        {footer || null}
                    </div>
                </div>
            </div>
        </Fade>

    ) : null
}

export default VerticalLayout
